<template>
  <div class="ui form" v-bind:class="{ loading: loading }">
    <!-- <h3 class="ui dividing header">{{ $t("course preinscription filter") }}</h3> -->
    <div class="fields">
      <div class="five column wide field">
        <label for="">{{ $t("branch") }}</label>
        <div
          class="ui multiple search selection dropdown"
          ref="branch_dropdown"
        >
          <input type="hidden" name="ddwn" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="five column wide field">
        <label for="">{{ $t("career") }}</label>
        <div
          class="ui multiple search selection dropdown"
          ref="career_dropdown"
        >
          <input type="hidden" name="ddwn" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="five column wide field">
        <label for="">{{ $t("studying time") }}</label>
        <div
          class="ui multiple search selection dropdown"
          ref="studying_time_dropdown"
        >
          <input type="hidden" name="ddwn" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="one column wide field">
        <label for="">{{ $t("search") }}</label>
        <div class="ui blue icon button" @click="search">
          <i class="search icon"></i>
        </div>
      </div>
    </div>
    <div class="fields">
      <!-- <div class="seven column wide field">
        <label for="">{{ $t("course") }}</label>
        <div class="ui search" ref="course_search">
          <input
            class="prompt"
            type="text"
            :placeholder="$t('search course')"
          />
          <div class="results"></div>
        </div>
      </div> -->
    </div>
    <table class="ui striped celled very compact selectable table" ref="table">
      <thead>
        <tr>
          <th></th>
          <th>{{ $t("student") }}</th>
          <th>{{ $t("career") }}</th>
          <th>{{ $t("branch") }}</th>
          <th>{{ $t("studying time") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in preinscriptions" :key="idx">
          <td>
            <div class="ui checkbox">
              <input type="checkbox" v-model="item.checked" /> <label></label>
            </div>
          </td>
          <td>
            {{ item.std_student.student_id_card }} -
            {{ item.std_student.name }}
          </td>
          <td>{{ item.std_career.name }}</td>
          <td>{{ item.std_branch.name }}</td>
          <td>{{ item.std_studying_time.name }}</td>
          <td>
            <div class="ui basic mini icon button" @click="emit_add(item)">
              <i class="green plus icon"></i>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th colspan="6">
            <div
              class="ui right floated small basic labeled icon button"
              @click="add_selected"
            >
              <i class="blue plus icon"></i> {{ $t("add selected") }}
            </div>
            <div class="ui small basic labeled icon button" @click="check_all">
              <i class="check icon"></i> {{ $t("check all") }}
            </div>
            <div
              class="ui small basic labeled icon button"
              @click="uncheck_all"
            >
              <i class="remove icon"></i> {{ $t("uncheck all") }}
            </div>
          </th>
        </tr>
        <tr>
          <th colspan="6">
            <div class="fields" style="margin-bottom: 0">
              <div class="inline field">
                <label for="">{{ $t("select first") }}</label>
                <input type="text" v-model="first_records" style="width: 4em" />
                <label for=""> {{ $t("records") }}</label>
              </div>
              <div class="field">
                <div
                  class="ui small basic labeled icon button"
                  @click="add_first_records"
                >
                  <i class="green check icon"></i> {{ $t("select") }}
                </div>
              </div>
            </div>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  warning_toast /* init_search */,
} from "@/utils";

export default {
  name: "PreinscriptionFilter",
  props: {
    careers: Array,
    branches: Array,
    studying_times: Array,
    section: Object,
    season: Object,
    course: String,
    users: Array,
  },
  data() {
    return {
      branch: "",
      career: "",
      studying_time: "",
      // course: "",
      preinscriptions: [],
      first_records: "",
      loading: false,
      datatable: undefined,
    };
  },
  methods: {
    search() {
      let vm = this;
      vm.loading = true;
      local_api(vm, "post", "/course/assignation/do-get-preinscriptions", {
        b: vm.branch,
        c: vm.career,
        cs: vm.course,
        s: vm.season.season_id,
        t: vm.studying_time,
      })
        .then((r) => {
          vm.preinscriptions = r.preinscriptions
            .sort((a, b) => {
              if (a.std_student.student_id_card > b.std_student.student_id_card)
                return 1;
              else if (
                a.std_student.student_id_card < b.std_student.student_id_card
              )
                return -1;
              return 0;
            })
            .map((p) => {
              p.checked = false;
              return p;
            });
          // vm.sections = r.sections.map((s) => {
          //   return {
          //     uuid: s.uuid,
          //     name: s.name,
          //     professor: s.professor_id,
          //     students: s.setup.students,
          //     attributes: s.setup.attributes,
          //     branch: s.branch_id,
          //     studying_times: s.studying_time_id,
          //   };
          // });
          if (vm.datatable) {
            vm.datatable.destroy();
          }
          setTimeout(() => {
            // if (window.jQuery.fn.DataTable.isDataTable(vm.$refs.table)) {
            vm.datatable = window.jQuery(vm.$refs.table).DataTable();
          }, 1000);
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    init_dropdowns() {
      let vm = this;

      window
        .jQuery(vm.$refs.career_dropdown)
        .dropdown("setup menu", {
          values: vm.careers.map((c) => {
            return { name: c.name, value: c.career_id };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.career = value;
          },
        });

      window
        .jQuery(vm.$refs.branch_dropdown)
        .dropdown("setup menu", {
          values: vm.branches.map((b) => {
            return { name: b.name, value: b.branch_id };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.branch = value;
          },
        });

      window
        .jQuery(vm.$refs.studying_time_dropdown)
        .dropdown("setup menu", {
          values: vm.studying_times.map((b) => {
            return { name: b.name, value: b.studying_time_id };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.studying_time = value;
          },
        });

      /** Lock fields depending on logged user */
      let sessionUser = vm.$session.get("user");
      let targetUser = vm.users.find((usr) => {
        return String(usr.user_id) == String(sessionUser.user_id);
      });
      if (targetUser && targetUser.std_user && targetUser.std_user.branch_id) {
        window
          .jQuery(vm.$refs.branch_dropdown)
          .dropdown("set selected", targetUser.std_user.branch_id);
        window
          .jQuery(vm.$refs.branch_dropdown)
          .closest(".field")
          .addClass("disabled");
      } else {
        window
          .jQuery(vm.$refs.branch_dropdown)
          .closest(".field")
          .removeClass("disabled");
      }
    },
    // init_search() {
    //   let vm = this;

    //   let onSearchResponse = (data) => {
    //     let rslt = [];
    //     data.map((r) => {
    //       rslt.push({
    //         title: r.name,
    //         course: r,
    //       });
    //     });
    //     return { results: rslt };
    //   };
    //   let onSearchSelect = (data) => {
    //     vm.course = data.course.course_id;
    //   };

    //   init_search(
    //     vm,
    //     vm.$refs.course_search,
    //     "search course",
    //     onSearchResponse,
    //     onSearchSelect,
    //   );
    // },
    emit_add(item) {
      this.$emit("add_item", item);
    },
    check_all() {
      let vm = this;
      vm.preinscriptions = vm.preinscriptions.map((p) => {
        p.checked = true;
        return p;
      });
    },
    uncheck_all() {
      let vm = this;
      vm.preinscriptions = vm.preinscriptions.map((p) => {
        p.checked = false;
        return p;
      });
    },
    add_selected() {
      let vm = this;
      let selected = vm.preinscriptions.filter((p) => {
        return p.checked;
      });
      vm.$emit("add_selected", selected);
    },
    clear() {
      this.preinscriptions = [];
    },
    add_first_records() {
      let vm = this;
      let number_of_records = vm.first_records;
      let nmbr = Number(number_of_records);
      if (!Number.isNaN(nmbr)) {
        for (let i = 0; i < nmbr; i++) {
          const element = vm.preinscriptions[i];
          if (element) {
            element.checked = true;
          }
          // console.log("number_of_records", number_of_records);
        }
      } else {
        warning_toast(vm.$t("the value must be a number"));
      }
    },
  },
  mounted() {
    let vm = this;
    vm.init_dropdowns();
    // vm.init_search();
  },
};
</script>
